<template>
  <div>
    <!-- Loading 组件的内容 -->
    <div
      element-loading-text="loading"
      :lock="true"
      :visible="visible"
      :fullscreen="fullscreen"
      v-loading.fullscreen.lock="visible">
      <div class="loading-content">
        <!-- Loading... -->
        <!-- 这里可以放置加载时的动画或文本等内容 -->
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "loading",
  data() {
    return {
      visible: false,
      fullscreen: true
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>
 
<style scoped>
.loading-content {
  /* 样式内容 */
}
</style>


// WEBPACK FOOTER //
// src/components/loading/index.vue